import {FC} from 'react';

type HealthDeclarationProgressBarProps = {
  totalSteps: number;
  currentStep: number;
}

const HealthDeclarationProgressBar: FC<HealthDeclarationProgressBarProps> = ({totalSteps, currentStep}) => {
  const currentProgress = Math.round(currentStep / totalSteps * 100);
  return (
    <div className='pt-8 pb-3 flex flex-col items-end'>
      <div className='w-full bg-gray-progress h-3 rounded-md'>
        <div
          className={`bg-navy-primary h-full rounded-md`}
          style={{width: currentProgress + '%'}}
        ></div>
      </div>
      <div className='text-navy-primary font-normal text-base pt-2 flex w-full'>
        <div className='md:hidden'>Följ stegen nedan:</div>
        <div className='ml-auto'>{currentStep} / {totalSteps}</div>
      </div>
    </div>
  );
};

export default HealthDeclarationProgressBar;
